import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CustomFilterBuilder from './collection/derived-query/CustomFilterBuilder';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { FILTER } from 'drapcode-constant';

export class RowLevelSecurity extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollections({ projectId, version });
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    this.props.actions.loadProjectPlugins({ projectId, version });
    this.props.actions.getPermissionFlags({ projectId });
  }

  render() {
    const { collections, match, actions, commonActions, common } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      createRowLevelSecurityFilterInCollectionPending,
      selectedCollection,
      permissionFlags,
    } = collections;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { updatedCollections } = common;
    return (
      <CommonPageComponent>
        <CollectionHeaderNav
          label={types.ROW_LEVEL_SECURITY}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionsPending={loadProjectCollectionsPending}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionsPending ||
          (loadProjectCollectionDetailPending && (
            <div className="text-center">
              <CustomLoader
                loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
                size="20px"
                color="#303453"
              />
            </div>
          ))}
        {selectedCollection && (
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <CustomFilterBuilder
                actions={actions}
                commonActions={commonActions}
                version={version}
                projectId={projectId}
                filters={selectedCollection.rowLevelSecurityFilter}
                collection={selectedCollection}
                collections={collections}
                showQueryCreateLoader={createRowLevelSecurityFilterInCollectionPending}
                flag={permissionsArray.includes(FILTER)}
                rls={true}
                updatedCollections={updatedCollections}
              />
            </div>
          </div>
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RowLevelSecurity);
